// frontend/src/content/legalDocuments.js

export const CURRENT_TOU_VERSION = '1.0';
export const CURRENT_PRIVACY_VERSION = '1.0';

export const TERMS_OF_USE = {
  version: CURRENT_TOU_VERSION,
  lastUpdated: '2026-02-04',
  content: {
    title: 'Terms of Use',
    sections: [
      {
        heading: '1. Using the App',
        content:
          'By using The Ascended platform (the “Service”), you’re agreeing to these Terms. If you don’t agree, you can’t use the Service. We’re keeping this readable on purpose — the goal is clarity, not surprises.'
      },
      {
        heading: '2. What the Service Is',
        content:
          'The Ascended is a tabletop RPG platform that provides tools for character creation, campaign management, and gameplay support for The Ascended system.'
      },
      {
        heading: '3. Accounts & Security',
        content:
          'If you create an account, you’re responsible for keeping it secure and for activity under that account. If you think someone got access to your account, let us know as soon as possible.'
      },
      {
        heading: '4. Your Content',
        content:
          'You own what you create (characters, campaigns, notes, etc.). We only need permission to host, store, and display that content as part of making the Service work for you and your group.'
      },
      {
        heading: '5. Don’t Be a Problem',
        content:
          'Please don’t use the Service to break laws, harass people, impersonate others, upload malware, or try to damage or exploit the platform. Basically: don’t be a jerk, and don’t break the app.'
      },
      {
        heading: '6. Our Stuff',
        content:
          'The Ascended platform and original content we provide (including rules text, UI, and other materials) are protected by copyright and related laws. Don’t copy, resell, or redistribute our content without permission.'
      },
      {
        heading: '7. Ads (Limited)',
        content:
          'Some parts of the Service may display limited ads to help cover hosting and development costs. We keep ads out of core gameplay workflows and we won’t intentionally make the experience annoying to chase ad revenue.'
      },
      {
        heading: '8. Service Availability',
        content:
          'We do our best to keep things stable, but the Service is provided “as is” and “as available.” Things may change, features may evolve, and outages can happen.'
      },
      {
        heading: '9. Termination',
        content:
          'We can suspend or terminate accounts that violate these Terms or harm the platform/other users. We don’t do this lightly, but we will protect the community and the Service.'
      },
      {
        heading: '10. Changes to These Terms',
        content:
          'We may update these Terms from time to time. If changes are significant, we’ll make a reasonable effort to notify you in the app or via email. Continuing to use the Service after an update means you accept the updated Terms.'
      },
      {
        heading: '11. Contact',
        content:
          'Questions? Use the in-app feedback system or email support@ow-games.com.'
      }
    ]
  }
};

export const PRIVACY_POLICY = {
  version: CURRENT_PRIVACY_VERSION,
  lastUpdated: '2026-02-04',
  content: {
    title: 'Privacy Policy',
    sections: [
      {
        heading: '1. The Short Version',
        content:
          'We collect only what we need to run the Service. We don’t sell your personal information. We use limited ads to fund hosting and development, and we try to keep everything straightforward.'
      },
      {
        heading: '2. Information We Collect',
        content:
          'This may include: account details (like email/username), content you create (characters/campaigns/notes), basic usage data (features used, error logs), and technical data needed for security and reliability (like IP address, device/browser info).'
      },
      {
        heading: '3. How We Use Information',
        content:
          'We use information to operate the Service, maintain your account, support gameplay features, improve performance, respond to support/feedback, prevent abuse, and meet legal obligations.'
      },
      {
        heading: '4. Advertising',
        content:
          'We use Google AdSense to display limited ads in a few places. Google may use cookies or similar technologies to show ads, including personalized ads where allowed. You can control ad personalization through Google’s ad settings.'
      },
      {
        heading: '5. Cookies & Similar Tech',
        content:
          'Cookies help with core functionality (like keeping you signed in), preferences, analytics/performance, and advertising. You can control cookies through your browser settings. If you disable cookies, some features may not work as expected.'
      },
      {
        heading: '6. Sharing & Third Parties',
        content:
          'We do not sell your personal information. We may share data (a) with your game group as part of the Service’s normal functionality, (b) with vendors that help us operate the Service (hosting, analytics, ads), (c) if required by law, or (d) if you explicitly consent.'
      },
      {
        heading: '7. Data Security',
        content:
          'We take reasonable steps to protect your information, including secure authentication and standard security practices. No system is perfect, but we treat security seriously.'
      },
      {
        heading: '8. Data Retention',
        content:
          'We keep your information as long as your account is active or as needed to provide the Service. If you delete your account, we’ll delete or anonymize your personal information within a reasonable timeframe unless we must keep something for legal reasons.'
      },
      {
        heading: '9. Your Choices',
        content:
          'You can access and update your account info, manage cookie preferences, and control ad personalization through Google. If you want help with your data, reach out.'
      },
      {
        heading: '10. International Users',
        content:
          'The Service is operated from the United States. If you use it from outside the U.S., your information may be processed in the United States.'
      },
      {
        heading: '11. Changes to This Policy',
        content:
          'If we update this Privacy Policy, we’ll update the date above. If the changes are significant, we’ll make a reasonable effort to notify you.'
      },
      {
        heading: '12. Contact',
        content:
          'Questions about privacy? Use the in-app feedback system or email privacy@ow-games.com.'
      }
    ]
  }
};
